import {InputText} from '@/components/commons/input-text/InputText'
import styled from 'styled-components'

export const StyledUserInputEvaluation = styled(InputText)`
    ::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
    ::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
`
